import React from "react";
import main from "../../assets/images/boxTwo.webp";

const LoadingPage = () => {
  return (
    <div className="fixed top-0 left-0 w-full h-full bg-white z-[9999] flex items-center justify-center">
      <div className="relative w-24 h-24">
        <div className="absolute inset-0 border-4 border-yellow-400 rounded-full animate-spin border-t-transparent"></div>
        <img
          src={main}
          alt="Loading"
          loading="lazy"
          className="absolute w-16 -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
        />
      </div>
    </div>
  );
};

export default LoadingPage;
